<template>
  <div class="experience-search-form mb-0" v-if="EXPERIENCE_ENABLED">
    <p class="text-center text-md-left">{{ FORMS_PARAGRAPH }}</p>
    <div>
      <p class="text-center text-md-left">{{ FORM_DESCRIPTION3 }}</p>
      <form id="formExperience">
        <div class="row">
          <div class="col-12 inputVolo">
            <div class="form-group">
              <label for="cittaId">Aereoporto</label>
              <v-select
                class="form-control"
                id="cittaId"
                v-model="search.aereoporto"
                placeholder="Aereoporto di partenza"
                :options="list"
              />
            </div>
          </div>
          <div class="col-12 inputPartenza">
            <div class="form-group">
              <label for="partenzaId">Partenza il</label>
              <CustomDatepicker
                id="partenzaId"
                v-model="search.partenza"
                :disabled-dates="disabledDatesPartenza"
              />
            </div>
          </div>
          <div class="col-12 inputPasseggeri">
            <div class="form-group">
              <label for="passeggeriId">Passeggeri</label>
              <CamereSelector id="passeggeriId" v-model="search.camere" />
            </div>
          </div>
          <div v-if="isMobile" class="col-12 mt-2">
            <button
              id="creaViaggioExperienceMobile"
              type="button"
              class="btn btn-primary orange w-100"
              @click="onClick"
              :disabled="!enabledConfirm"
            >
              crea il tuo viaggio
            </button>
          </div>
        </div>
        <div v-if="!isMobile" class="buttons">
          <button
            id="creaViaggioExperience"
            type="button"
            class="btn btn-primary orange"
            @click="onClick"
            :disabled="!enabledConfirm"
          >
            crea il tuo viaggio
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CustomDatepicker from "../../common/CustomDatePicker";
import CamereSelector from "../../common/CamereSelector";
import ItemExperience from "../experience/HorizontalItemExperience";
import { PRODUCT_EXPERIENCE } from "../../../../types/products";
import AnalyticEvents from "../../../common/AnalyticEvents";
import MobileDetector from "../../../common/MobileDetector";
import ContentUtils from "../../../utils/ContentUtils";

export default {
  name: "ExperienceSearchForm",
  mixins: [AnalyticEvents, MobileDetector, ContentUtils],
  components: { ItemExperience, CamereSelector, CustomDatepicker },
  data() {
    return {
      disabledDatesPartenza: {
        to: new Date(),
      },
      search: {
        product: PRODUCT_EXPERIENCE,
        aereoporto: null,
        partenza: null,
        camere: [
          {
            adults: 2,
            childs: [],
          },
        ],
      },
    };
  },
  computed: {
    list() {
      return this.getTypesAereoporti().map(function (item) {
        return { label: item.name, value: item.id };
      });
    },
    enabledConfirm: function () {
      const { aereoporto, partenza } = this.search;
      return aereoporto != null && partenza != null;
    },
    experiences() {
      return this.getExperiences();
    },
  },
  methods: {
    ...mapGetters(["getSearch", "getTypesAereoporti"]),
    ...mapActions(["addSearch"]),
    onClick: function () {
      this.trackHomeSearchExperience();
      this.addSearch(this.search);
      this.$scrollTo("#app");
      this.$emit("change", PRODUCT_EXPERIENCE);
      this.$router.push("/experience-selection");
    },
  },
  created() {
    const search = this.getSearch();
    if (search && search.product === PRODUCT_EXPERIENCE) {
      this.search = { ...search };
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/home/ExperienceSearchForm.vue